import {
  apiRequest,
  PNSuploadSKPNS,
  PNSdetailCPNS,
  masterRank,
  masterSignatoryOfficial,
  masterDocumentType,
} from "../../../../../services/adapters/kepegawaian/DokumenPNSService";

class UploadSKRepository {
  fetchUploadSk = async (query) => {
    return await apiRequest(
      "post",
      PNSuploadSKPNS,
      {
        body: query,
      },
      true
    );
  };

  fetchDetail = async (query) => {
    return await apiRequest(
      "get",
      PNSdetailCPNS,
      {
        params: query,
      },
      true
    );
  };

  fetchRank = async (query) => {
    return await apiRequest(
      "get",
      masterRank,
      {
        params: query,
      },
      true
    );
  };

  fetchSignatoryOfficial = async (query) => {
    return await apiRequest(
      "get",
      masterSignatoryOfficial,
      {
        params: query,
      },
      true
    );
  };

  fetchDocumentType = async (query) => {
    return await apiRequest(
      "get",
      masterDocumentType,
      {
        params: query,
      },
      true
    );
  };
}

export default UploadSKRepository;
